"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowStepsContainer = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Responsive_1 = require("@amzn/atoz-web/Responsive");
const Flex_1 = require("@amzn/atoz-web/Flex");
const progress_bar_1 = require("@amzn/stencil-react-components/progress-bar");
const Button_1 = require("@amzn/atoz-web/Button");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const ErrorFallback_1 = require("../../../components/Shared/ErrorFallback");
const WorkflowStepsContainerTypes_1 = require("./WorkflowStepsContainerTypes");
const WorkflowStepsContainer = ({ currentStepTitle = '', currentStep = 1, setCurrentStep, totalSteps, isActionable, isCurrentStepValid, showErrorFallback = false, onSubmit, onClose, onBack, onContinue, children, submitButtonAriaLabel, progressTrackerAriaLabel, closeButtonAriaLabel }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { matches } = (0, Responsive_1.useBreakpoints)();
    const isMobileViewPoint = !!matches.s;
    const stepTitleRef = (0, react_1.useRef)(null);
    const onBackBtnClk = () => {
        setCurrentStep(currentStep - 1);
        stepTitleRef.current.focus();
        if (onBack) {
            onBack();
        }
    };
    const onContBtnClk = () => {
        if (!isCurrentStepValid) {
            return;
        }
        setCurrentStep(currentStep + 1);
        stepTitleRef.current.focus();
        if (onContinue) {
            onContinue();
        }
    };
    const renderCancelBtn = () => {
        if (isActionable) {
            return (react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Tertiary, onClick: onClose, dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_CANCEL_BTN, "aria-label": t(`${closeButtonAriaLabel}`) }, t('time_and_attendance_Cancel')));
        }
    };
    const renderBackBtn = () => {
        if (currentStep > 1) {
            return (react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Secondary, onClick: onBackBtnClk, dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_BACK_BTN, "aria-label": t('time_and_attendance_PunchWorkflow_Back_A11y') }, t('time_and_attendance_Back')));
        }
    };
    const renderActionBtn = () => {
        if (currentStep < totalSteps) {
            return (react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Primary, onClick: onContBtnClk, dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_CONT_BTN, disabled: !isCurrentStepValid, "aria-label": t('time_and_attendance_PunchWorkflow_Continue_A11y') }, t('time_and_attendance_Continue')));
        }
        else if (currentStep === totalSteps) {
            if (isActionable) {
                return (react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Primary, onClick: onSubmit, dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_SUBMIT_BTN, "aria-label": t(`${submitButtonAriaLabel}`) }, t('time_and_attendance_Submit')));
            }
            else {
                return (react_1.default.createElement(Button_1.Button, { variant: Button_1.ButtonVariant.Primary, onClick: onClose, dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_CLOSE_BTN, "aria-label": t(`${closeButtonAriaLabel}`) }, t('time_and_attendance_Close')));
            }
        }
    };
    return (react_1.default.createElement(View_1.View, { dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_STEPS_CONTAINER },
        react_1.default.createElement(Flex_1.Flex, { flexDirection: 'column', margin: { bottom: 'S300' }, width: '30%' },
            react_1.default.createElement(Text_1.Text, { color: 'neutral90', fontSize: 'T200', margin: { bottom: 'S200' } }, t('time_and_attendance_PunchWorkflow_StepIndex', {
                currentStep,
                totalSteps
            })),
            react_1.default.createElement(progress_bar_1.ProgressBar, { progress: currentStep / totalSteps, status: progress_bar_1.Status.Positive, "aria-label": t(`${progressTrackerAriaLabel}`, {
                    currentStep,
                    totalSteps
                }) })),
        react_1.default.createElement(Text_1.H1, { ref: stepTitleRef, tabIndex: -1, fontSize: 'T500', margin: { top: 'S300' }, fontWeight: 500 }, currentStepTitle),
        showErrorFallback ? react_1.default.createElement(ErrorFallback_1.ErrorFallback, null) : children,
        isMobileViewPoint ? (react_1.default.createElement(Flex_1.Flex, { dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_BTNS_MOBILE, flexDirection: 'column', margin: { top: 'S400' }, gridGap: 'S300' },
            renderActionBtn(),
            renderBackBtn(),
            renderCancelBtn())) : (react_1.default.createElement(Flex_1.Flex, { dataTestId: WorkflowStepsContainerTypes_1.WF_DATA_TEST_IDS.WORKFLOW_BTNS_WEB, flexDirection: 'row', justifyContent: isActionable ? 'space-between' : 'flex-end', margin: { top: 'S400' } },
            renderCancelBtn(),
            react_1.default.createElement(Flex_1.Flex, { flexDirection: 'row-reverse', gridGap: 'S300' },
                renderActionBtn(),
                renderBackBtn())))));
};
exports.WorkflowStepsContainer = WorkflowStepsContainer;
